import React from 'react';
import ProductCard from '../components/ProductCard';

function HomePage({ products, onAddToCart, onToggleWishlist, onQuickView, wishlist = [], searchQuery = '', activeFilter = null, pagination = null, loadMoreProducts = null }) {
  const getFilterTitle = () => {
    if (activeFilter === 'best-selling') {
      return 'Best-Selling Items';
    } else if (activeFilter === '5-star') {
      return '5-Star Rated Products';
    }
    return null;
  };

  return (
    <>
      {/* Filter/Search Results Header */}
      {(searchQuery || activeFilter) && (
        <div className="max-w-screen-2xl mx-auto mt-4 sm:mt-6 px-3 sm:px-4 md:px-6 lg:px-8">
          {searchQuery ? (
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
              Search results for "<span className="text-primary">{searchQuery}</span>"
              <span className="text-sm text-gray-500 font-normal ml-2">({products.length} {products.length === 1 ? 'result' : 'results'})</span>
            </h2>
          ) : (
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
              {getFilterTitle()}
              <span className="text-sm text-gray-500 font-normal ml-2">({products.length} {products.length === 1 ? 'product' : 'products'})</span>
            </h2>
          )}
        </div>
      )}
      
      {/* Products Grid */}
      <section className="max-w-screen-2xl mx-auto my-4 sm:my-6 md:my-8 px-3 sm:px-4 md:px-6 lg:px-8">
        {products.length === 0 ? (
          <div className="text-center py-12">
            <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <p className="text-gray-500 font-medium text-lg">No products found</p>
            <p className="text-gray-400 text-sm mt-2">
              {searchQuery ? 'Try adjusting your search terms' : 'No products available at the moment'}
            </p>
          </div>
        ) : (
          <>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-5 lg:gap-6">
            {products.map(product => (
              <ProductCard 
                key={product.id} 
                product={product}
                onAddToCart={onAddToCart}
                onToggleWishlist={onToggleWishlist}
                onQuickView={onQuickView}
                isWishlisted={wishlist.includes(product.id)}
              />
            ))}
          </div>
            
            {/* Load More Button - Only show when not searching/filtering and there are more products */}
            {!searchQuery && !activeFilter && pagination && pagination.hasMore && loadMoreProducts && (
              <div className="flex justify-center mt-8 sm:mt-10 md:mt-12">
                <button
                  onClick={loadMoreProducts}
                  disabled={pagination.loadingMore}
                  className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-primary via-primary-dark to-secondary text-white rounded-lg sm:rounded-xl font-semibold text-sm sm:text-base hover:shadow-lg hover:shadow-primary/30 hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 flex items-center gap-2 sm:gap-3"
                >
                  {pagination.loadingMore ? (
                    <>
                      <svg className="animate-spin h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span>Loading more products...</span>
                    </>
                  ) : (
                    <>
                      <span>Load More Products</span>
                      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </section>
    </>
  );
}

export default HomePage;
